import { formatNumber } from "../../../helpers/number/numberFormat"
import theme from "../../theme"
import { Box } from '../Box'
import { NextButton } from "../Button"
import { Icon } from "../Icon"
import { Image } from "../Image"
import { openOfficeTab } from '../../../helpers/cretool-extjs/Tabs'
import SeeMoreDetailIcon from '../../../assets/icons/icon_see_more_details.svg'
import NoBuildingImage from '../../../assets/icons/no_building_image.png'
import { useApp } from "../../../contexts/AppContext"
import { translateText } from "../../../helpers/util"

export const OfficeSimilarBuildingCard = ({ building, index }) => {
    const { language, translations, userCountry } = useApp()

    const handleClickImgOffice = (office) => {
        openOfficeTab(office);
    }

    const hasImage = building.img_fachada && building.img_fachada !== "" && building.img_fachada !== "null";

    return (
        <div style={styles.container}>
            <div style={styles.numberContainer}>{index}</div>
            <Box style={styles.contentContainer}>
                <div style={styles.photoContainer}>
                    {hasImage ? (
                        <img src={`https://d6bmyxfy7viyd.cloudfront.net/90x115/${building.img_fachada}`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
                    ) : (
                        <div style={styles.noImageContainer}>
                            <img src={NoBuildingImage} width={'100%'} height={'90%'} style={{ objectFit: 'cover' }} />
                            <div style={styles.noImageOverlay}>
                                {translateText("Imagem do edifício não disponível", language, translations, userCountry)}
                            </div>
                        </div>
                    )}
                </div>
                <Box style={styles.buildingNameAddressContainer}>
                    <div style={styles.buildingName} onClick={() => handleClickImgOffice(building)}>{building.nome}</div>
                    <div>{building.endereco}</div>
                    <Box style={{ marginTop: 5 }}>
                        <Box style={styles.statsContainer}>
                            <Icon color={'#000'} icon={'floorPlanIcon'} width={20} />
                            <div style={styles.statsText}>{formatNumber(building.area_locavel_total, 0)}</div>
                        </Box>
                        <Box style={styles.statsContainer}>
                            <Icon color={'#000'} icon={'floorPlanVacancyIcon'} width={20} />
                            <div style={styles.statsText}>{formatNumber(building.area_locavel_disponivel, 0)}</div>
                        </Box>
                        <Box style={styles.statsContainer}>
                            <Icon color={'#000'} icon={'percentualIcon'} width={20} />
                            <div style={styles.statsText}>{formatNumber(building.area_locavel_disponivel / building.area_locavel_total * 100, 2)}</div>
                        </Box>
                    </Box>
                </Box>
                <div style={styles.seeMoreDetails}>
                    <div style={styles.seeMoreDetailsIcon} onClick={() => handleClickImgOffice(building)}>
                        <img src={SeeMoreDetailIcon} width={'100%'} height={'100%'} />
                    </div>
                </div>
            </Box>
        </div>
    )
}

const styles = {
    container: {
        backgroundColor: '#D9D9D9',
        marginLeft: 5,
        marginRight: 5,
        position: 'relative'
    },
    numberContainer: {
        backgroundColor: theme.palette.secondary.main,
        position: 'absolute',
        width: 20,
        height: 20,
        color: '#FFF',
        borderRadius: 10,
        top: -6,
        left: -4,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 12,
        zIndex: 2
    },
    contentContainer: {
        flexDirection: 'row',
        display: 'flex'
    },
    photoContainer: {
        width: 90,
        height: 115
    },
    noImageContainer: {
        width: '100%',
        height: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#EAEAEA',
        padding: 4,
        boxSizing: 'border-box',
        zIndex: 1
    },
    noImageOverlay: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.65)',
        color: '#FFF',
        fontSize: 8.5,
        textAlign: 'center',
        padding: '4px 2px',
        fontWeight: '600',
        lineHeight: '1.1',
        wordBreak: 'break-word',
        fontFamily: 'sans-serif'
    },
    buildingNameAddressContainer: {
        flexDirection: 'column', 
        display: 'flex', 
        boxSizing: 'border-box',
        flex: 1,
        fontSize: 12,
        minWidth: 230,
        padding: 5
    },
    buildingName: {
        cursor: 'pointer',
        fontWeight: '700'
    },
    buildingAddress: {
        color: '#565656'
    },
    statsContainer: {
        flexDirection: 'row',
        display: 'flex'
    },
    statsText: {
        fontSize: 14,
        fontWeight: '700',
        marginLeft: 6
    },
    seeMoreDetails: {
        position: 'absolute',
        bottom: 10,
        right: 10
    },
    seeMoreDetailsIcon: {
        width: 22,
        height: 22,
        cursor: 'pointer'
    }
}